module.exports = __webpack_public_path__ + "img/ascend_gold9.be43effd.png";